import React, { Component } from 'react';
import "./MobileFlipcards.css";
class MobileFlipcards extends Component {
    render() {
        return (
        <div className='mfcard'>
          
           <div className='mobilecardf'>
   <div className='mobilecardfimage'>
    
   <img
    src="https://res.cloudinary.com/dtfzxqpoy/image/upload/v1708632775/image_327_tg9gsn.png"
        alt=""/>
    </div> 

            <div className='mobilecardftext'>
            Contribute directly to initiatives that uplift 
            underprivileged communities and enhance 
            their well-being.</div> 
           </div>

           <div className='mobilecardf'>
   <div className='mobilecardfimage'>
    
   <img
    src="https://res.cloudinary.com/dtfzxqpoy/image/upload/v1708632775/image_327_tg9gsn.png"
        alt=""/>
    </div> 

            <div className='mobilecardftext'>
            Connect with a diverse network of passionate volunteers dedicated to making a 
            difference in rural communities.</div> 
           </div>

           <div className='mobilecardf'>
   <div className='mobilecardfimage'>
    
   <img
    src="https://res.cloudinary.com/dtfzxqpoy/image/upload/v1708632775/image_327_tg9gsn.png"
        alt=""/>
    </div> 

            <div className='mobilecardftext'>
            Expand your skill set and gain valuable experience that can enrich your personal and professional growth.</div> 
           </div>

           <div className='mobilecardf'>
   <div className='mobilecardfimage'>
    
   <img
    src="https://res.cloudinary.com/dtfzxqpoy/image/upload/v1708632775/image_327_tg9gsn.png"
        alt=""/>
    </div> 

            <div className='mobilecardftext'>
            Join Lokarpan in its mission to empower individuals and families, ensuring access to education, healthcare, and sustainable livelihoods for rural populations.</div> 
           </div>

           </div>
        );
    }
}

export default MobileFlipcards;